import { motion } from "framer-motion";
import { ChevronDown, ShieldAlert } from "lucide-react";
import { trackEvent } from "@/lib/analytics";
import { Button } from "@/components/ui/button";

const HeroSection = () => {
  return (
    <section className="relative flex min-h-screen items-center justify-center overflow-hidden px-4 pt-16">
      {/* Background effects */}
      <div className="absolute inset-0 -z-10">
        <div className="absolute left-1/4 top-1/4 h-96 w-96 rounded-full bg-primary/10 blur-[128px]" />
        <div className="absolute bottom-1/4 right-1/4 h-96 w-96 rounded-full bg-secondary/10 blur-[128px]" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_0%,hsl(var(--background))_70%)]" />
      </div>

      <div className="container mx-auto text-center">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}>

          <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-border bg-muted/50 px-4 py-2 text-sm text-muted-foreground">
            <ShieldAlert className="h-4 w-4 text-cyber-amber" />
            El 95% de los incidentes involucran errores humanos
          </div>
        </motion.div>

        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.15, ease: "easeOut" }}
          className="mx-auto max-w-4xl font-display text-4xl font-bold leading-tight tracking-tight sm:text-5xl md:text-6xl lg:text-7xl">

          Tu mayor vulnerabilidad no es tu software.{" "}
          <span className="gradient-text">
Son tus empleados.</span>
        </motion.h1>

        <motion.p initial={{ opacity: 0, y: 30 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
        className="mx-auto mt-6 max-w-2xl text-lg text-muted-foreground sm:text-xl">Formación en ciberseguridad diseñada para pymes. 
Convierte a tu equipo en tu mejor, y más económico, firewall.


        
        </motion.p>

        <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8, delay: 0.45, ease: "easeOut" }}
        className="mt-10 flex flex-col items-center gap-4 sm:flex-row sm:justify-center">

          <Button
            size="lg"
            className="glow-blue bg-primary px-8 text-lg font-semibold text-primary-foreground hover:bg-primary/90"
            onClick={() => {
              trackEvent("hero_cta_click", { button: "phishing_simulation" });
              document.getElementById("simulacion")?.scrollIntoView({ behavior: "smooth" });
            }}>

            ¿Serías capaz de detectar un ataque?
          </Button>
          <Button
            variant="outline"
            size="lg"
            className="border-border text-lg hover:bg-muted"
            onClick={() => {
              trackEvent("hero_cta_click", { button: "maturity_test" });
              document.getElementById("test")?.scrollIntoView({ behavior: "smooth" });
            }}>

            Evalúa tu nivel de riesgo
          </Button>
        </motion.div>

        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ duration: 1, delay: 1.2 }}
          className="mt-20">

          <ChevronDown className="mx-auto h-6 w-6 animate-bounce text-muted-foreground" />
        </motion.div>
      </div>
    </section>);

};

export default HeroSection;